import styled from "styled-components";
import { getBreakpoint, getDirection } from "../../../../../../../common-deprecated/themes/common";
import { theme as lexusTheme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const WinterToggle = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    right: ${lexusTheme.space[4] / 2}px;
    justify-content: flex-end;
    @media ${getBreakpoint("up", "md")} {
        position: static;
        margin-right: ${lexusTheme.space[5]}px;
    }
    @media ${getBreakpoint("up", "lg")} {
        margin-right: 0;
    }
`;

export const Label = styled.span`
    display: none;
    @media ${getBreakpoint("up", "md")} {
        display: inline-block;
    }
`;

export const ToggleStates = styled.button<{ isActive: boolean }>`
    
    display: inline-flex;
    position: relative;
    justify-content: space-around;
    width: 80px;
    margin-${getDirection("left")}: 10px;
    padding: 8px 10px;
    font-size: 1.6rem;
    color: white;
    background-color: ${({ isActive }) => (isActive ? lexusTheme.colors.black : lexusTheme.colors.grey3)};
    border: none;
    border-radius: 50px;

    &::after {
        display: block;
        position: absolute;
        top: 3px;
        ${getDirection("left")}: ${({ isActive }) => (isActive ? 45 : 7)}px;
        width: 26px;
        height: 26px;
        content: " ";
        background-color: ${({ theme }) => theme.color.lightest};
        border-radius: 36px;
        transition: left 0.3s;
    }
`;
